import { render, staticRenderFns } from "./notification-count.vue?vue&type=template&id=f75031a2&"
import script from "./notification-count.vue?vue&type=script&lang=js&"
export * from "./notification-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports